export const WORKSPACE_USER_TYPE = {
  MASTER: 'master',
  ADMIN: 'admin',
  MEMBER: 'member',
} as const;
export type WorkspaceUserType = (typeof WORKSPACE_USER_TYPE)[keyof typeof WORKSPACE_USER_TYPE];

export const WORKSPACE_TYPE = {
  PUBLIC: 'Public',
  PRIVATE: 'Private',
  RESTRICTED: 'Restricted',
  DEFAULT: 'Default',
} as const;
export type WorkspaceType = (typeof WORKSPACE_TYPE)[keyof typeof WORKSPACE_TYPE];

export const WORKSPACE_EMAIL_TEMPLATE = {
  INVITE_WORKSPACE: 'inviteWorkspace',
  INVITE_WORKSPACE_MEMBER: 'inviteWorkspaceMember',
} as const;
export type WorkspaceEmailTemplate = (typeof WORKSPACE_EMAIL_TEMPLATE)[keyof typeof WORKSPACE_EMAIL_TEMPLATE];

export const WORKSPACE_MODAL_CONTENT_TYPE = {
  SWITCH_ACCOUNT: 'switchAccount',
  ALREADY_JOINED: 'alreadyJoinedWorkspace',
  JOIN_MULTIPLE: 'joinMultipleWorkspace',
  JOIN_SINGLE: 'joinPrevAccountWithoutPlanSingleWorkspace',
  COPY_LINK: 'copyLinkInviteWorkspace',
  ENTERPRISE_JOIN_OTHER_WORKSPACE: 'workspaceJoinOtherWorkspace',
} as const;
export type WorkspaceModalContentType = (typeof WORKSPACE_MODAL_CONTENT_TYPE)[keyof typeof WORKSPACE_MODAL_CONTENT_TYPE];
